export default __webpack_public_path__ + "static/media/headerWithePhone.abbb3580.svg";